var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import alt from "alt-instance";

var PrivateKeyActions = function () {
    function PrivateKeyActions() {
        _classCallCheck(this, PrivateKeyActions);
    }

    _createClass(PrivateKeyActions, [{
        key: "addKey",
        value: function addKey(private_key_object, transaction) {
            // returned promise is deprecated
            return function (dispatch) {
                return new Promise(function (resolve) {
                    dispatch({ private_key_object: private_key_object, transaction: transaction, resolve: resolve });
                });
            };
        }
    }, {
        key: "loadDbData",
        value: function loadDbData() {
            // returned promise is deprecated
            return function (dispatch) {
                return new Promise(function (resolve) {
                    dispatch(resolve);
                });
            };
        }
    }]);

    return PrivateKeyActions;
}();

export default alt.createActions(PrivateKeyActions);